import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import "./index.css" 
// 定义 Badge 组件
const BsyBadge = ({ children, className, color, pill, ...props }) => {
  const classes = classNames(
    'bsy-badge',
    color && `bsy-badge-${color}`,
    pill && 'bsy-badge-pill',
    className
  );
 
  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};
 
// 定义 propTypes 验证属性
BsyBadge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'body'
  ]),
  pill: PropTypes.bool
};
 
// 定义 defaultProps 设置默认属性
BsyBadge.defaultProps = {
  color: 'secondary',
  pill: false
};
 
export default BsyBadge;